
export type MigrateStateType = {
  sms?: {
    calls?: unknown;
  };
  app?: {
    calls?: {
      device: null | string;
      status: string;
      isCalling: boolean;
    };
  };
  [key: string]: unknown;
}

export const migrateState = (state: MigrateStateType | undefined) => {
  if (!state) return Promise.resolve(state);

  // Example: Ensure new field 'newFlag' is present
  if (state.sms && !state.sms.calls) {
    if (state.app) {
      state.app.calls = {
        device: null,
        status: '',
        isCalling: false
      };
    }
  }

  // Example: Rename a field
  //   if (state.user && state.user.oldField) {
  //     state.user.newField = state.user.oldField;
  //     delete state.user.oldField;
  //   }

  // Optional: remove legacy keys
  if ('google' in state) {
    delete state.google;
  }

  return Promise.resolve(state);
};